import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

import { theme } from '../../theme';

export interface FavoriteStarIconProps {
  style?: React.CSSProperties;
  selected?: boolean;
}

export const FavoriteStarIcon = ({
  style,
  selected = false,
}: FavoriteStarIconProps): ReactElement => {
  const backgroundColor = selected
    ? theme.palette.vibrant.primary
    : theme.palette.neutral.light;
  const borderColor = selected ? backgroundColor : '#fff';

  return (
    <SvgIcon style={{ fontSize: '1.1em', ...style }} viewBox="0 0 35 35.5">
      <g transform="translate(0 0)">
        <g transform="translate(1.66 1.121)">
          <g
            transform="translate(-1.66 -1.121)"
            fill={backgroundColor}
            stroke={borderColor}
            strokeWidth="1"
          >
            <rect width="35" height="35.5" rx="17.5" stroke="none" />
            <rect
              x="0.5"
              y="0.5"
              width="34"
              height="34.5"
              rx="17"
              fill="none"
            />
          </g>
        </g>
        <g transform="translate(-7 -7)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="48"
            viewBox="0 -960 960 960"
            width="48"
            fill="#383838"
          >
            <path d="m354-287 126-76 126 77-33-144 111-96-146-13-58-136-58 135-146 13 111 97-33 143Zm-61 83.92 49.62-212.54-164.93-142.84 217.23-18.85L480-777.69l85.08 200.38 217.23 18.85-164.93 142.84L667-203.08 480-315.92 293-203.08ZM480-470Z" />
          </svg>
        </g>
      </g>
    </SvgIcon>
  );
};
